import {
  Sun,
  Cloud,
  CloudRain,
  CloudSnow,
  CloudDrizzle,
  CloudLightning,
  CloudFog,
  CloudSun,
} from 'lucide-react';

interface WeatherIconProps {
  code: number;
  size?: number;
}

export function WeatherIcon({ code, size = 16 }: WeatherIconProps) {
  const props = { className: 'text-muted-foreground', style: { width: size, height: size } };

  // WMO Weather interpretation codes
  // 0: Clear sky
  if (code === 0) return <Sun {...props} />;
  // 1-3: Mainly clear, partly cloudy, overcast
  if (code <= 2) return <CloudSun {...props} />;
  if (code === 3) return <Cloud {...props} />;
  // 45, 48: Fog
  if (code === 45 || code === 48) return <CloudFog {...props} />;
  // 51-55: Drizzle
  if (code >= 51 && code <= 55) return <CloudDrizzle {...props} />;
  // 56-57: Freezing drizzle
  if (code >= 56 && code <= 57) return <CloudDrizzle {...props} />;
  // 61-65: Rain
  if (code >= 61 && code <= 65) return <CloudRain {...props} />;
  // 66-67: Freezing rain
  if (code >= 66 && code <= 67) return <CloudRain {...props} />;
  // 71-77: Snow
  if (code >= 71 && code <= 77) return <CloudSnow {...props} />;
  // 80-82: Rain showers
  if (code >= 80 && code <= 82) return <CloudRain {...props} />;
  // 85-86: Snow showers
  if (code >= 85 && code <= 86) return <CloudSnow {...props} />;
  // 95-99: Thunderstorm
  if (code >= 95) return <CloudLightning {...props} />;

  return <Cloud {...props} />;
}
